<span (clickOutside)="onClickedOutside($event)" class="selected-columns-wrapper">
  @if (selectedColumns?.length > 0) {
    <span class="selected-columns-number"> {{ selectedColumns?.length }}/{{ allColumns?.length }} </span>
  }
  <button
    mat-icon-button
    [color]="selectedColumns.length > 0 ? 'accent' : 'primary'"
    (click)="toggleList()"
    matTooltip="Filter columns">
    <mat-icon>view_column</mat-icon>
  </button>
  @if (selectedColumns.length > 0) {
    <button mat-icon-button color="accent" (click)="reset()" matTooltip="Show all columns">
      <mat-icon>clear</mat-icon>
    </button>
  }

  @if (showColumns) {
    <mat-selection-list [(ngModel)]="selectedColumns" (ngModelChange)="onModelChange()" class="column-filter-list">
      @for (tta of allColumns; track tta) {
        <mat-list-option [value]="tta.name">
          {{ tta.label }}
        </mat-list-option>
      }
    </mat-selection-list>
  }
</span>
